<template>
  <div class="overflow-hidden cashout-request">
    <b-overlay
      :show="isLoading"
      rounded
      opacity="0.6"
      spinner
      spinner-variant="primary"
      >
      <b-form-radio-group class="col-md-12" id="cashoutRequestType" v-model="reqType" name="orderType" buttons>
        <b-form-radio size="sm" value="nominal" button-variant="outline-primary">{{ $t('cashout.type.type1') }}</b-form-radio>
        <b-form-radio size="sm" value="mse" button-variant="outline-info">{{ $t('cashout.type.type2') }}</b-form-radio>
      </b-form-radio-group>
      <b-button-group v-if="!isCreate" class="col-md-12 col-sm-12 mt-1">
        <b-button variant="success" @click="toggleCreate">{{ $t('helper.make-request') }}</b-button>
      </b-button-group>
      <transition name="ttb">
      <b-form v-if="isCreate" @submit.prevent="sendRequest" class="px-3 pt-3">
        <b-form-group :label="$t('cashout.amount')">
          <currency-input v-model="requestModel.amount"></currency-input>
        </b-form-group>
        <b-form-group v-if="reqType === 'mse'" :label="$t('cashout.share-code')">
          <b-form-select v-model="requestModel.share_code" :options="mseShareCodes"></b-form-select>
        </b-form-group>
        <b-form-group :label="$t('cashout.info')">
          <b-form-textarea rows="3" v-model="requestModel.description"></b-form-textarea>
        </b-form-group>
        <div class="d-flex justify-content-center">
          <b-button-group>
            <b-button type="submit" variant="outline-success">{{ $t('helper.make-request') }}</b-button>
            <b-button variant="outline-danger" @click="toggleCreate">{{ $t('helper.refuse') }}</b-button>
          </b-button-group>
        </div>
      </b-form>
      </transition>
      <div class="mt-2 px-1">
        <div v-if="!requests || !(requests && requests.length > 0)" class="item text-14 text-gray text-center">
          <hr/>
          <i class="far fa-file" />
          {{ $t('helper.empty') }}
        </div>
        <ul class="history-wrapper" ref="request-list" id="request-list">
          <cashout v-for="(item, i) in requests" :request="item" :key="i" :cancelRequest="cancelRequest" />
        </ul>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import api from '../../api/cashoutRequests';
import Cashout from '../../components/sidebar/Cashout';
import { MseShareCodes } from '../../constants';

const StateOption = {
  approved: { variant: 'success', text: 'Биелсэн', },
  cancelled: { variant: 'danger', text: 'Цуцалсан', },
  new: { variant: 'info', text: 'Шинэ', },
  done: { variant: 'success', text: 'Биелсэн', },
  null: { variant: 'dark', text: 'NA', },
  undefined: { variant: 'dark', text: 'NA', }
};

export default {
  name: 'CashOutRequest',
  data() {
    return {
      StateOption,
      isLoading: false,
      isCreate: false,
      reqType: 'nominal',
      requestModel: {
        amount: 0,
        share_code:'',
        description: '',
        state: 'new',
      },
      requests: [],
      page: 1,
      HistoryLastPage: 1,
      mseShareCodes: MseShareCodes,
    };
  },
  components: {
    'cashout': Cashout,
  },
  mounted() {
    this.page = 0;
    // const listElm = document.querySelector('#request-list');
    const listElm = this.$refs['request-list'];
    if (listElm) {
      listElm.addEventListener('scroll', () => {
        if(listElm.scrollTop + listElm.clientHeight >= listElm.scrollHeight) {
          setTimeout(() => {
            this.page += 1;
            if (this.page <= this.HistoryLastPage) this.fetchData();
          }, 400);
        }
      });
    } 
    this.fetchData();
  },
  beforeDestroy() {
    // const elm = document.querySelector('#request-list');
    this.$refs['request-list'].removeEventListener('scroll', () => {});
  },
  methods: {
    async fetchData(pageParam = null, typeChanged = false) {
      this.isLoading = true;
      try {
        const { data: { data, ...page } } = await api.getCashOutRequests({ reqType: this.reqType, page: pageParam || this.page });
        this.HistoryLastPage = page && page.last_page;
        if (typeChanged) this.requests = [...data];
        else this.requests.push(...data);
      } catch (e) {
        this.requests = [];
      }
      this.isLoading = false;
    },
    setReqType(type) {
      this.reqType = type;
    },
    toggleCreate() {
      this.isCreate = !this.isCreate;
    },
    async sendRequest() {
      this.isLoading = true;
      try {
        const { data } = await api.createRequest({
          account_type: this.reqType,
          ...this.requestModel,
        });
        await this.fetchData({}, true);
        this.isCreate = false;
        this.$bvToast.toast(this.$t('helper.request-success'), { title: this.$t('helper.success'), variant: 'info' });
      } catch (e) {
        this.$bvToast.toast(this.$t('helper.system-error'), { title: this.$t('helper.error'), variant: 'error' });
      }
      this.isLoading = false;
    },
    cancelRequest(item) {
      this.$swal({
        icon: 'warning',
        title: `Та ${this.$options.filters.currency(item.amount, '', '₮')} дүнтэй хүсэлтийг цуцлах уу?`,
        confirmButtonText: this.$t('helper.cancel'),
        confirmButtonColor: '#ff7674',
        cancelButtonColor: '#c3c3c3',
        cancelButtonText: this.$t('helper.refuse'),
        showCancelButton: true,
        showConfirmButton: true,
        reverseButtons: false,
      }).then(async ({ dismiss, value }) => {
        if (!dismiss && !!value) {
          this.isLoading = true;
          try {
            await api.cancelRequest(item);
            await this.fetchData({}, true);
            this.$bvToast.toast(this.$t('helper.cancel-success'), { title: this.$t('helper.success'), variant: 'info' });
          } catch (e) {
            this.$bvToast.toast(this.$t('helper.system-error'), { title: this.$t('helper.error'), variant: 'error' });
          }
          this.isLoading = false;
        }
      }).catch((err) => { console.error(err); });
    },
  },
  watch: {
    reqType() {
      this.fetchData('0', true);
    }
  }
}
</script>
<style lang="scss" src="../../../sass/partials/sidebar-submenu.scss"></style>

<style scoped>
  .ttb-leave-active,
  .ttb-enter-active {
    transition: .4s;
  }
  .ttb-enter {
    transform: translate(0, -100%);
  }
  .ttb-leave-to {
    transform: translate(0, -100%);
  }
</style>
